var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "legendContainer" },
    [
      _c(
        "v-layout",
        [
          _c("v-flex", [
            _c("div", { staticClass: "ntstSectionTitle legendSectionHeader" }, [
              _vm._v("Alerts")
            ])
          ])
        ],
        1
      ),
      _c("v-divider", { staticClass: "legendDivider" }),
      _vm._l(_vm.alerts, function(code, index) {
        return _c(
          "v-flex",
          { key: "asc-" + index, staticClass: "legendItem" },
          [
            _c("alert-visualized-coded-entry", {
              staticClass: "alert legendItemIcon",
              attrs: {
                "visualized-coded-entry": code,
                alertDisplayName: code.displayName
              }
            }),
            _c("span", { staticClass: "legendItemText" }, [
              _vm._v(_vm._s(code.displayName))
            ])
          ],
          1
        )
      }),
      _c(
        "v-layout",
        [
          _c("v-flex", [
            _c("div", { staticClass: "ntstSectionTitle legendSectionHeader" }, [
              _vm._v("Rooms")
            ])
          ])
        ],
        1
      ),
      _c("v-divider", { staticClass: "legendDivider" }),
      _vm._l(_vm.roomStatusCodes, function(code, index) {
        return _c(
          "v-flex",
          { key: "rsc-" + index, staticClass: "legendItem" },
          [
            _c(
              "v-icon",
              {
                staticClass: "legendItemIcon",
                style: _vm.codeSampleStyleUsingForeground(code)
              },
              [_vm._v("fas fa-square-full")]
            ),
            _c("span", { staticClass: "legendItemText" }, [
              _vm._v(_vm._s(code.displayName))
            ])
          ],
          1
        )
      }),
      _c(
        "v-layout",
        [
          _c("v-flex", [
            _c("div", { staticClass: "ntstSectionTitle legendSectionHeader" }, [
              _vm._v("Clients")
            ])
          ])
        ],
        1
      ),
      _c("v-divider", { staticClass: "legendDivider" }),
      _vm._l(_vm.dischargeStatusCodes, function(code, index) {
        return _c(
          "v-flex",
          { key: "dsc-" + index, staticClass: "legendItem" },
          [
            _c(
              "v-icon",
              {
                staticClass: "legendItemIcon",
                style: _vm.codeSampleStyleUsingBackground(code)
              },
              [_vm._v("fas fa-square-full")]
            ),
            _c("span", { staticClass: "legendItemText" }, [
              _vm._v(_vm._s(code.displayName))
            ])
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }